<template>
    <div id="contenedor-componente-avatar">
      <template
        v-if="tipo === 'nombre'">
        <v-avatar
          :size="size"
          :color="color">
          <span
            class="text-h5"
            :class="{ 'white--text': dark }">
            {{ $inicialesNombre(nombre) }}
          </span>
        </v-avatar>
      </template>
      <template
        v-if="tipo === 'imagen'">
        <v-avatar
          :size="size"
          :color="color">
          <img :src="imgUrl" :alt="nombre">
        </v-avatar>
      </template>
      <template
        v-if="tipo === 'icono'">
        <v-avatar
          :color="color">
          <v-icon
            :dark="dark">
            {{ icono }}
          </v-icon>
        </v-avatar>
      </template>
    </div>
</template>

<script>
export default {
  name: 'componenteAvatar',
  props: {
    tipo: {
      type: String,
      required: true,
    },
    nombre: {
      type: String,
      required: false,
    },
    imgUrl: {
      type: String,
      required: false,
    },
    icono: {
      type: String,
      required: false,
    },
    size: {
      type: Number,
      required: false,
      default: 48,
    },
    color: {
      type: String,
      required: false,
      default: 'grey lighten-2',
    },
    dark: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
